module.exports = __webpack_public_path__ + "static/img/sprite2310.bf689da.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/sprite2310.png
// module id = MZrg
// module chunks = 7